/* LIARINA · lia.js — görünme, sekmeler, önce/sonra, video şeridi */
(function(){
  function kur(kok){
    kok=kok||document;
    // görünme animasyonu
    var el=kok.querySelectorAll('.lia-belir:not(.lia-gorundu)');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(g){g.forEach(function(x){if(x.isIntersecting){x.target.classList.add('lia-gorundu');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px'});
      el.forEach(function(e){io.observe(e)});
    } else el.forEach(function(e){e.classList.add('lia-gorundu')});
    // sekmeler
    kok.querySelectorAll('[data-lia-sekme]').forEach(function(s){
      if(s._lia)return; s._lia=1;
      var d=s.querySelectorAll('.lia-sekme__dugme'),p=s.querySelectorAll('.lia-sekme__panel');
      d.forEach(function(b,i){b.addEventListener('click',function(){d.forEach(function(x,j){x.setAttribute('aria-selected',j===i)});p.forEach(function(x,j){x.hidden=j!==i})})});
    });
    // önce / sonra
    kok.querySelectorAll('.lia-os__kutu').forEach(function(k){
      if(k._lia)return; k._lia=1;
      var r=k.querySelector('.lia-os__aralik'); if(!r)return;
      var f=function(){k.style.setProperty('--oran',r.value+'%')}; r.addEventListener('input',f); f();
    });
    // video şeridi
    kok.querySelectorAll('.lia-video').forEach(function(v){
      if(v._lia)return; v._lia=1;
      v.querySelectorAll('.lia-video__kart').forEach(function(k){
        var vid=k.querySelector('video'),b=k.querySelector('.lia-video__oynat'); if(!vid||!b)return;
        b.addEventListener('click',function(){v.querySelectorAll('video').forEach(function(o){if(o!==vid){o.pause();o.closest('.lia-video__kart').classList.remove('oynuyor')}});vid.controls=true;vid.muted=false;vid.play();k.classList.add('oynuyor')});
      });
      var s=v.querySelector('.lia-video__serit');
      v.querySelectorAll('.lia-video__ok').forEach(function(o){o.addEventListener('click',function(){s.scrollBy({left:(o.dataset.yon==='geri'?-1:1)*s.clientWidth*.8,behavior:'smooth'})})});
    });
    // sayaç bandı: sayıları görünce say
    kok.querySelectorAll('[data-lia-say]').forEach(function(b){
      if(b._lia)return; b._lia=1;
      var ham=b.getAttribute('data-lia-say'),m=ham.match(/^(\D*)([\d.,]+)(.*)$/); if(!m)return;
      var hedef=parseInt(m[2].replace(/[.,]/g,''),10),nokta=/[.,]/.test(m[2]); if(!hedef)return;
      var bic=function(n){var t=String(n);return nokta?t.replace(/\B(?=(\d{3})+(?!\d))/g,'.'):t};
      var calis=function(){var t0=performance.now(),d=1600;(function ad(t){var p=Math.min(1,(t-t0)/d),e=1-Math.pow(1-p,3);b.textContent=m[1]+bic(Math.round(hedef*e))+m[3];if(p<1)requestAnimationFrame(ad)})(t0)};
      if('IntersectionObserver' in window){var o=new IntersectionObserver(function(g){if(g[0].isIntersecting){o.disconnect();calis()}});o.observe(b)}
    });
    // ürün sayfası: emojili fayda metni -> kart listesi (metin aynen kalır)
    if(document.querySelector('.lia-urun-isaret')) kok.querySelectorAll('.emoji-benefits-container').forEach(function(c){
      if(c._lia)return; c._lia=1;
      var re=/^((?:\p{Extended_Pictographic}|\p{Regional_Indicator})(?:️|‍|\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Regional_Indicator})*)/u;
      var cikti=[],liste=null,adet=0;
      c.innerHTML.split(/<br\s*\/?>|<\/?p[^>]*>/i).forEach(function(h){
        h=h.trim(); var d=document.createElement('div'); d.innerHTML=h;
        var t=d.textContent.replace(/ /g,' ').trim(); if(!t)return;
        var m=t.match(re);
        if(m){
          var i=h.indexOf(m[1]); var g=(i>=0?h.slice(0,i)+h.slice(i+m[1].length):h).replace(/^(\s|&nbsp;)+/,'');
          if(!liste){liste=document.createElement('ul');liste.className='lia-fl';cikti.push(liste)}
          var li=document.createElement('li'); li.innerHTML='<span class="lia-fl__e" aria-hidden="true"></span><span class="lia-fl__t"></span>';
          li.firstChild.textContent=m[1]; li.lastChild.innerHTML=g; liste.appendChild(li); adet++;
          var k=li.lastChild.querySelector('strong'); if(k&&k.textContent.trim()===li.lastChild.textContent.trim())li.className='lia-fl--vurgu';
        } else {
          liste=null; var p=document.createElement('p'); p.className='lia-fl__giris'; p.innerHTML=h; cikti.push(p);
        }
      });
      if(adet<2)return;
      c.textContent=''; cikti.forEach(function(x){c.appendChild(x)}); c.classList.add('lia-fl-hazir');
    });
    // mobil satın al çubuğu: satın alma alanı görünmüyorken açılır
    kok.querySelectorAll('[data-lia-yapiskan]').forEach(function(c){
      if(c._lia)return; c._lia=1;
      var sec=c.getAttribute('data-lia-yapiskan'),h=document.querySelector(sec)||document.querySelector('product-info');
      var form=document.querySelector('product-info product-form')||document.querySelector('product-info')||h;
      c.querySelector('[data-lia-git]').addEventListener('click',function(e){e.preventDefault();var y=(h||form).getBoundingClientRect().top+window.scrollY-90;window.scrollTo({top:y,behavior:'smooth'})});
      if(!form||!('IntersectionObserver' in window))return;
      var gecti=false;
      new IntersectionObserver(function(g){var r=g[0];gecti=!r.isIntersecting&&r.boundingClientRect.top<0;c.classList.toggle('acik',gecti)}).observe(form);
    });
  }
  if(document.readyState!=='loading')kur(); else document.addEventListener('DOMContentLoaded',function(){kur()});
  document.addEventListener('shopify:section:load',function(e){kur(e.target)});
})();
